import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './screens/Home/Home';
import AboutUs from './screens/AboutUs/AboutUs';
import Contact from './screens/Contact/Contact';
import TTS from './screens/TTS/TTS';
import InvestmentSolution from './screens/InvestmentSolution/InvestmentSolution';
import PrivacyPolicy from './screens/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './screens/TermsOfService/TermsOfService';
import RiskDisclosure from './screens/RiskDisclosure/RiskDisclosure';
import AzamraHomes from './screens/AzamraHomes/AzamraHomes';
import Marketplace from './screens/Marketplace/Marketplace';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/treasury-solutions" element={<TTS />} />
        <Route path="/products/tts" element={<Navigate to="/treasury-solutions" replace />} />
        <Route path="/products/treasury-solutions" element={<Navigate to="/treasury-solutions" replace />} />
        <Route path="/investment-solution" element={<InvestmentSolution />} />
        <Route path="/products/investment-solution" element={<Navigate to="/investment-solution" replace />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/marketplace/azamra-homes" element={<AzamraHomes />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/risk-disclosure" element={<RiskDisclosure />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
